// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper"; // Starter Custom Code
import { clearSearchHistory, getSearchHistory } from "@insite/client-framework/Services/AutocompleteService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { IconMemo, IconPresentationProps } from "@insite/mobius/Icon";
import Clock from "@insite/mobius/Icons/Clock";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { autocompleteGetLinkProps, autocompleteProps } from "@store/Themes/common/props/autocomplete";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { getContentSearchCurrentTab } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
import constants from "@store/constants";
import getContentSearchUrl from "@store/Framework/Common/Utilities/getContentSearchUrl";
/* Starter Custom Code - End */

interface OwnProps {
    focusedQuery?: string;
    goToUrl: (url: string) => void;
    extendedStyles?: SearchHistoryStyles;
}

/* Starter Custom Code - Start */
const mapStateToProps = (state: ApplicationState) => {
    const {
        searchSettings: { searchHistoryEnabled, searchPath },
        extensionContentSearchSettings,
    } = getSettingsCollection(state);
    const enableContentSearchResults =
        extensionContentSearchSettings && extensionContentSearchSettings.enableContentSearchResults;
    const contentSearchCurrentTab = enableContentSearchResults ? getContentSearchCurrentTab(state) : "";
    return {
        searchHistoryEnabled,
        searchPath,
        enableContentSearchResults,
        contentSearchCurrentTab,
    };
};
/* Starter Custom Code - End */

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface SearchHistoryStyles {
    headerText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    itemWrapper?: InjectableCss;
    icon?: IconPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
    clearLink?: LinkPresentationProps;
    // Starter Custom Code
    query?: TypographyPresentationProps;
}

export const searchHistoryStyles: SearchHistoryStyles = {
    headerText: autocompleteProps.headerText,
    link: autocompleteProps.link,
    focusedLink: autocompleteProps.focusedLink,
    query: { ellipsis: true },
    clearLink: mergeProps<SearchHistoryStyles["clearLink"]>(autocompleteGetLinkProps("text.link"), {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    }),
};

const styles = searchHistoryStyles;

class SearchHistory extends React.Component<Props> {
    private readonly styles: SearchHistoryStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
    }

    clearLinkClickHandler = () => {
        clearSearchHistory();
        this.forceUpdate();
    };

    render() {
        if (!this.props.searchHistoryEnabled) {
            return null;
        }

        const searchHistory = getSearchHistory();
        if (searchHistory.length === 0) {
            return null;
        }

        const styles = this.styles;
        return (
            <StyledWrapper {...styles.wrapper}>
                <Typography {...styles.headerText}>{translate("Search History")}</Typography>
                <ul /* Starter Custom Code */>
                    {searchHistory.map(searchHistoryItem => (
                        <li key={searchHistoryItem.query} /* Starter Custom Code */>
                            {/* Starter Removed - IconMemo */}
                            <Link
                                {...(this.props.focusedQuery === searchHistoryItem.query
                                    ? styles.focusedLink
                                    : styles.link)}
                                onClick={() => {
                                    if (searchHistoryItem.redirectUri) {
                                        this.props.goToUrl(searchHistoryItem.redirectUri);
                                    } /* Starter Custom Code */ else if (this.props.enableContentSearchResults) {
                                        /* Starter Custom Code - Start */
                                        const contentSearchPrefixUrl = getContentSearchUrl(
                                            searchHistoryItem.query,
                                            this.props.searchPath,
                                            this.props.contentSearchCurrentTab ||
                                                constants.contentSearch.tabKey.products,
                                        );
                                        this.props.goToUrl(contentSearchPrefixUrl);
                                        /* Starter Custom Code - End */
                                    } else {
                                        this.props.goToUrl(
                                            `/${this.props.searchPath}?query=${encodeURIComponent(
                                                searchHistoryItem.query,
                                            )}`,
                                        );
                                    }
                                }}
                            >
                                <Typography {...styles.query} /* Starter Custom Code */>
                                    {searchHistoryItem.query}
                                </Typography>
                            </Link>
                        </li>
                    ))}
                </ul>
                <Link {...styles.clearLink} onClick={this.clearLinkClickHandler}>
                    {translate("Clear Search History")}
                </Link>
            </StyledWrapper>
        );
    }
}

export default connect(mapStateToProps)(SearchHistory);
